import dayjs from "lib/dayjs";
import { createCompassPdf } from "reporting/pdf/createCompassPdf";
import { addKpiCards } from "reporting/pdf/addKpiCards";
import { addReportTable } from "reporting/pdf/addReportTable";
import { addKeyValueBlock } from "reporting/pdf/pdfLayout";
import {
  fmtCurrency,
  fmtDate,
  safeFilePart,
} from "reporting/pdf/pdfFormatters";

export default async function exportDebtPortfolioPeriodPdf({
  orgId = null,
  portfolioName = "Portfolio",
  orgName = "",
  criteria,
  rows = [],
  totals = {},
}) {
  const isPeriod = criteria?.reportType === "period";
  const dateLabel = isPeriod
    ? `${dayjs(criteria.startDate).format("M/D/YYYY")} – ${dayjs(
        criteria.endDate
      ).format("M/D/YYYY")}`
    : dayjs(criteria?.selectedDate).format("M/D/YYYY");

  const ctx = await createCompassPdf({
    orgId,
    reportTitle: "DebtStudio - Portfolio Scheduled Debt Service",
    orgName: orgName || portfolioName,
    asOfLabel: `${isPeriod ? "Period" : "Date"}: ${dateLabel}`,
    createdStamp: new Date(),
    orientation: "portrait",
    branding: "unbranded",
  });

  let y = ctx.margins.top + 10;
  y = addKeyValueBlock(
    ctx,
    [
      { label: "Portfolio", value: portfolioName },
      { label: "Report Type", value: isPeriod ? "Period" : "Date" },
      { label: isPeriod ? "Selected Period" : "Selected Date", value: dateLabel },
    ],
    y,
    { columns: 2, labelWidth: 104, rowHeight: 14, columnGap: 28 }
  );

  y = addKpiCards(
    ctx,
    [
      { label: "Total Principal", value: fmtCurrency(totals.principal, 2) },
      { label: "Total Interest", value: fmtCurrency(totals.interest, 2) },
      { label: "Total Debt Service", value: fmtCurrency(totals.total, 2) },
    ],
    y
  );

  addReportTable(
    ctx,
    {
      title: "Scheduled Debt Service",
      columns: [
        { key: "date", label: "Date", format: fmtDate },
        { key: "issue", label: "Issue" },
        { key: "principal", label: "Principal", align: "right", format: (v) => fmtCurrency(v, 2) },
        { key: "interest", label: "Interest", align: "right", format: (v) => fmtCurrency(v, 2) },
        { key: "total", label: "Debt Service", align: "right", format: (v) => fmtCurrency(v, 2) },
      ],
      rows,
      foot: [
        "",
        "Total",
        fmtCurrency(totals.principal, 2),
        fmtCurrency(totals.interest, 2),
        fmtCurrency(totals.total, 2),
      ],
      columnStyles: {
        0: { cellWidth: 62 },
        1: { cellWidth: "auto" },
        2: { cellWidth: 82 },
        3: { cellWidth: 82 },
        4: { cellWidth: 88 },
      },
      didParseCell: (data) => {
        if (data.section === "foot" && data.column.index >= 2) {
          data.cell.styles.halign = "right";
        }
      },
      rowPageBreak: "avoid",
    },
    y
  );

  ctx.finalize();
  const fileDate = isPeriod ? criteria.endDate : criteria.selectedDate;
  const fileName = `DebtStudio_Portfolio_Scheduled_Debt_Service_${safeFilePart(
    portfolioName
  )}_${fileDate}.pdf`;
  ctx.doc.save(fileName);
  return { doc: ctx.doc, fileName };
}
